export default __webpack_public_path__ + "static/media/et-so.c7d382c7.svg";